import { format, parseISO } from 'date-fns'

export const formatDate = date => (date ? format(parseISO(date), 'dd MMM yyyy') : '-')
export const formatDateTime = date => (date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-')
export const formatPeriod = (from, to) => `${formatDate(from)} - ${formatDate(to)}`
